import { render, staticRenderFns } from "./Instituicao.vue?vue&type=template&id=7fb4dfb9&scoped=true&"
import script from "./Instituicao.vue?vue&type=script&lang=js&"
export * from "./Instituicao.vue?vue&type=script&lang=js&"
import style0 from "./Instituicao.vue?vue&type=style&index=0&id=7fb4dfb9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb4dfb9",
  null
  
)

export default component.exports